import { Model } from 'modules/core/lib/mobx-rest'

interface IInvitation {
  [key: string]: any
}
class Invitation extends Model<IInvitation> {
  static urlRoot() {
    return '/invitations'
  }
}

export default Invitation
